import { useAppSelector } from "@/redux/hooks";
import { useCheckoutUI } from "../CheckoutUIProvider";

export const useLoadingCheckoutIntent = () => {
  const userProfile = useAppSelector((state) => state.userProfile);
  const [state] = useCheckoutUI();

  const loggedIn = !!userProfile?.userId;
  const hasCheckoutIntent = !!state.context.checkoutIntent;

  return {
    loading: loggedIn ? !hasCheckoutIntent : false,
  };
};
